import { useEffect, useState } from "react"
import { Modal } from "../../common"
import { getFormatNumber } from "../../../utils/convert"
import './index.scss'


const SkeletonLine = () => (
    <div style={{
        height: '20px',
        marginBottom: '8px',
        borderRadius: '4px',
        background: 'linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%)',
        backgroundSize: '200% 100%',
        animation: 'shimmer 1.5s infinite',
    }} />
)

const skeletonKeyframes = `@keyframes shimmer { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }`

const ReimprimirTicketsModal = ({ boletas, loading, expectedCount = 0, onConfirm, onCancel }) => {

    const [selected, setSelected] = useState([])

    useEffect(() => {
        if (boletas && boletas.length > 0) {
            setSelected(boletas.map(() => true))
        }
    }, [boletas])

    const selectedCount = selected.filter(Boolean).length

    const handleToggle = (index) => {
        setSelected(prev => prev.map((v, i) => i === index ? !v : v))
    }

    const handleSelectAll = () => {
        setSelected(boletas.map(() => true))
    }

    const handleDeselectAll = () => {
        setSelected(boletas.map(() => false))
    }

    const handleConfirm = () => {
        onConfirm(selected)
    }

    return (
        <Modal
            onEscape={onCancel}
            size="md"
            className="reimprimir-tickets-modal"
            title="Reimprimir tickets individuales"
            body={(
                <div>
                    <style>{skeletonKeyframes}</style>
                    {loading ? (
                        <div>
                            {[...Array(expectedCount || 3)].map((_, i) => <SkeletonLine key={i} />)}
                        </div>
                    ) : (
                        <>
                            <div className="m-bottom-10">
                                <button className="btn btn-outline-primary btn-sm m-right-10" onClick={handleSelectAll}>Seleccionar todas</button>
                                <button className="btn btn-outline-secondary btn-sm" onClick={handleDeselectAll}>Deseleccionar todas</button>
                            </div>
                            <div style={{ maxHeight: '400px', overflowY: 'auto', padding: '2px' }}>
                                {boletas.map((boleta, index) => (
                                    <div key={index} className="form-check m-top-5">
                                        <input
                                            type="checkbox"
                                            className="form-check-input"
                                            id={`boleta-${index}`}
                                            checked={selected[index] ?? false}
                                            onChange={() => handleToggle(index)}
                                        />
                                        <label className="form-check-label" htmlFor={`boleta-${index}`}>
                                            {boleta.label} - ${getFormatNumber(boleta.importe, 2)}
                                        </label>
                                    </div>
                                ))}
                            </div>
                        </>
                    )}
                </div>
            )}
            footer={(
                <div className="reimprimir-tickets-footer">
                    <button className="btn back-button" onClick={onCancel}>Cancelar</button>
                    <button
                        className="btn action-button"
                        onClick={handleConfirm}
                        disabled={loading || selectedCount === 0}
                    >
                        {loading ? 'Cargando...' : `Reimprimir ${selectedCount} seleccionada${selectedCount !== 1 ? 's' : ''}`}
                    </button>
                </div>
            )}
        />
    )
}

export default ReimprimirTicketsModal
